import { getVATPageUrl } from '@constants'
import { useBusinessContext } from '@context'
import { useTheme } from '@hooks'
import { IVatPeriod } from '@query'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { DateProgressListLink } from '../../components/DateProgressListItem'
import { DateProgressItem } from '../../components/DateProgressItem'

interface Props {
  vatPeriod: IVatPeriod
  isSelected: boolean
  isFirstOfType: boolean
  isLastOfType: boolean
  height: number
}

export const VatPeriodListItem: React.FC<Props> = ({
  vatPeriod,
  isSelected,
  isFirstOfType,
  isLastOfType,
  height
}) => {
  const [t] = useTranslation()
  const { slug } = useBusinessContext()
  const theme = useTheme()

  const itemUrl = useMemo(
    () =>
      getVATPageUrl(slug, {
        id: vatPeriod.id
      }),
    [slug, vatPeriod.id]
  )

  return (
    <StyledItemWrapper $itemHeight={height}>
      <StyledListItem
        to={itemUrl}
        $isSelected={isSelected}
        $isFirstOfType={isFirstOfType}
        $isLastOfType={isLastOfType}
      >
        <FlatDateProgressItem
          appearance="flat"
          dateFrom={new Date(vatPeriod.start_date)}
          dateTo={new Date(vatPeriod.end_date)}
          titleFrom={t('vatPage.periodStart')}
          titleTo={t('vatPage.periodEnd')}
          progressColor={percent => {
            if (vatPeriod.is_reported) {
              return theme.colors.success
            } else if (percent < 100) {
              return theme.colors.primary
            } else {
              return theme.colors.warning
            }
          }}
        />
      </StyledListItem>
    </StyledItemWrapper>
  )
}

const StyledItemWrapper = styled.div<{ $itemHeight: number }>`
  height: ${({ $itemHeight }) => $itemHeight}px;
`

const StyledListItem = styled(DateProgressListLink)``

const FlatDateProgressItem = styled(DateProgressItem)`
  width: 100%;
  height: 100%;
`
